// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7c4b35a9","732":"0fd16df2","977":"626ac647"}[chunkId] + ".chunk.js";
};